import React, { useState } from "react";
import { Intent, TextArea } from "@blueprintjs/core";
import { Icon } from "../../atoms/Icon";

import { useQuery } from "@apollo/react-hooks";
import { GetOpportunityDetails } from "./queries";

import styles from "../OpportunityDetails/OpportunityDetails.module.scss";

export function useOpportunityDetails({ opportunityId }) {
  const { loading, data } = useQuery(GetOpportunityDetails, {
    variables: { id: opportunityId },
    skip: !opportunityId
  });

  return {
    loading,
    opportunity: data && data.opportunities && data.opportunities[0]
  };
}

export const useOpportunityLinkAlert = ({ setAlertText, opportunity }) => {
  const brandName = opportunity ? opportunity.product.owner.name : "";
  const defaultIcon = <Icon name="warning-sign" color="#7a869b" size={32} />;

  const defaultAlertState = {
    visible: false,
    canEscapeKeyCancel: true,
    canOutsideClickCancel: true,
    cancelButtonText: "Cancel",
    confirmButtonText: "Apply",
    intent: Intent.DANGER,
    icon: defaultIcon,
    children: (
      <div className={styles.textAreaParent}>
        <p>Apply to partner with {brandName} on this opportunity?</p>
        <TextArea
          className={styles.textarea}
          fill
          placeholder={`(optional) Let ${brandName} know why you'd like to partner with them on this Opportunity.`}
          onChange={(event) => setAlertText(event.target.value)}
        />
      </div>
    )
  };

  const [alertState, setAlertState] = useState(defaultAlertState);

  const onAlertStateChange = (newAlertState) => {
    setAlertState({
      ...defaultAlertState,
      ...newAlertState
    });
  };

  const onAlertOpen = (newAlertState) => {
    setAlertState({
      ...defaultAlertState,
      ...{ visible: true }
    });
  };

  return {
    alertState,
    setAlertState: onAlertStateChange,
    defaultIcon,
    onAlertOpen
  };
};
